import { ONE_UNIT_CENTS_COUNT } from '@/shared/constants/common';

import { formatThousands } from './formatThousands';

export const formatCentsToDollars = (cents: number): string => {
  const normalizedCents = Math.round(cents);
  const dollars = Math.trunc(normalizedCents / ONE_UNIT_CENTS_COUNT);
  const remainder = Math.abs(normalizedCents % ONE_UNIT_CENTS_COUNT);

  if (remainder === 0) {
    return formatThousands(dollars);
  }

  return `${formatThousands(dollars)},${String(remainder).padStart(2, '0')}`;
};
